import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  callAPI,
  IsSmallScreen,
  MasterPages,
  Method
} from "../../commonFunctions/CommonFunctions";
import {
  AllPermissions,
  getPermissions,
  IPermission
} from "../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, {
  IOrderColumns
} from "../../Components/DataGrid/WSMobileDataGridAdvanced";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import { UpdateStatus } from "../UpdateStatus";
import { resetDataComponent } from "../../StateManagement/actions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import { useDispatch } from "react-redux";

export const ContactList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch();
  const isMobile = IsSmallScreen();
  const [rowId, setRowId] = useState<any>(null);
  // const [permission, setPermissions] = useState<IPermission>({ add: false, edit: false, view: false })
  // useEffect(() => {
  //     const { edit, view, add } = getPermissions(MasterPages.Contacts);
  //     setPermissions({ edit, view, add })
  // }, [])

  useEffect(() => {
    if (rowId) {
      openPopUp(metadataStatus, handleStatus, "40rem", handleCloseDialog);
    }
  }, [rowId]);
  AllPermissions.getInstance();
  const { add, edit, remove, view } = AllPermissions.getContactPermission;
  const source = {
    url: "leads/search",
    page: 1,
    pageSize: 10,
    filter: [
      {
        field: "leadType",
        operator: "eq",
        value: "1"
      }
    ],
    sort: []
  };

  /**
   * Edit function
   * @param action
   * @param row
   */
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/contact/edit/${row?.id}`);
    } else if (action === "Change Status") {
      setRowId(row?.id);
    }
    else if (action === 'Add Site Visit') {
      navigate(`/visit/${row?.id}/date/${row?.statusChagedAt}`);
    }
  };

  const columns: IColumns[] = [
    {
      header: "Company",
      fieldName: "company",
      type: "default"
    },
    {
      header: "Full Name",
      fieldName: "fullName",
      type: "default"
    },
    {
      header: "Email",
      fieldName: "email",
      tooltip: true,
      isHide: isMobile ? true : false,
      type: "default"
    },
    {
      header: "Mobile",
      fieldName: "mobile",
      tooltip: true,
      isHide: isMobile ? true : false,
      type: "default"
    },
    {
      header: "status",
      fieldName: "status",
      tooltip: true,
      type: "status"
    },
    // {
    //   header: "Created On",
    //   fieldName: "createdAt",
    //   isHide: isMobile ? true : false,
    //   type: "date"
    // },
    // {
    //   header: "Updated On",
    //   fieldName: "uptAt",
    //   isHide: isMobile ? true : false,
    //   type: "date"
    // },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined, "Change Status", "Add Site Visit"].filter(Boolean),
      // fieldCompare: {
      //   fieldName: "status",
      //   ValueCheck: { value: 'Qualified', actionCheck: "Add Site Visit" }
      // },
        hideSelectedActions: {
                fieldToHide: [
                    {
                        field: 'status',
                        hideValue: ['Contacted','New','Converted','Lost'],
                        hideActions: ['Add Site Visit']
                    },
                    // {
                    //     field: 'status',
                    //     hideValue: ['Completed'],
                    //     hideActions:  ['Reject','Approve']
                    // }
                ]
                // fieldToShow:[
                //   {
                //        field: 'status',
                //         showValue: ['Qualified'],
                //         showActions: ['Add Site Visit']
                //   }
                // ]
            },
      actionCallback: (action, row) => handleAction(action, row),
    }
  ];
  const mobColumns: IOrderColumns[] = [
    {
      header: "Full Name",
      fieldName: "fullName",
      labelSx: { fontWeight: "bold" },
      type: "default",
      sm: 6
      // otherFiels:[{fieldName:'email' ,type:'default'}]
      //  sortable: true
    },
    {
      header: "Email",
      fieldName: "email",
      tooltip: true,
      type: "default",
      sm: 6
    },
    {
      header: "Company",
      fieldName: "company",
      type: "default",
      sm: 6
    },

    {
      header: "Mobile",
      fieldName: "mobile",
      tooltip: true,
      sm: 6,
      type: "default"
    },
    {
      header: "status",
      fieldName: "status",
      tooltip: true,
      sm: 6,
      type: "default"
    },
    // {
    //   header: "Created On",
    //   fieldName: "createdAt",
    //   sm: 4,
    //   isBoderRadious: true,
    //   type: "date"
    // },
    // {
    //   header: "Updated On",
    //   fieldName: "uptAt",
    //   sm: 4,
    //   isBoderRadious: true,
    //   type: "date"
    // },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      sm: 4,
      actions: [edit ? "Edit" : undefined, "Change Status"].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
      
    }
  ];
  const handleClick = () => {
    navigate("/contact/create");
  };
  const transFormData = (data: any) => {
    if (data) {
      data.map((item: any) => {
        item.fullName = `${item?.firstName} ${item?.lastName ? item?.lastName : ""
          }`;
      });
      return data;
    }
  };

  const handleStatus = async (data: any) => {
    try {
      // setLoading(true);
      const response: any = await saveData(data);
      console.log("esponse is", response);
      setRowId(null);

      if (response && response.message) {
        dispatch(resetDataComponent("contactGrid"));
        showMessage(
          response.message || "Status updated successfully!",
          "success"
        );
      }
    } catch (e: any) {
      showMessage(e.error, "error");
    } finally {
      setRowId(null);
    }
  };

  const handleCloseDialog = (data?: any) => {
    setRowId(null);
  };

  const saveData = async (data: any) => {
    const request: any = {

      leadId: rowId,
      status: data?.newStatus,
      statusDetails: "Status Updated"


    };

    const response: any = await callAPI(`lead-status`, Method.PUT, request, rowId);
    return response;
  };

  const metadataStatus: IMetaData = {
    title: "Update Status",
    hideActions: false,
    content: (props: any, row: any) => <UpdateStatus {...props} contact={true} />,
    actions: [
      {
        label: "Cancel",
        className: "ws-cancel",
        type: "button"
      },
      {
        label: "Submit",
        onClick: handleStatus,
        type: "submit",
        autoFocus: true
      }
    ],
    isDragable: true
  };

  return (
    <>
      <Grid container spacing={2}>
        {view ? (
          <Grid item xs={12}>
            {!isMobile && (
              <WSDataGrid
                id="contactGrid"
                title="Contacts"
                columns={columns}
                transFormData={transFormData}
                source={source}
                addButton={
                  add ? { label: "New", color: "secondary" } : undefined
                }
                onAddButtonClick={handleClick}
                searchBox={{ fieldName: "firstName,company,lastName,mobile" }}
                gridHeaderSx={{
                  backgroundColor: "whitesmoke",
                  border: "1px solid whitesmoke"
                }}
              />
            )}
            {isMobile && (
              <WSMobileDataGridAdvanced
                transFormData={transFormData}
                title={"Contacts"}
                addButton={{ label: "New", color: "secondary" }}
                onAddButtonClick={handleClick}
                columns={mobColumns}
                id="contactGrid"
                source={source}
              />
            )}
          </Grid>
        ) : (
          <PermissionDenied />
        )}
      </Grid>
    </>
  );
});
